import { EllipsisVerticalIcon } from "@heroicons/react/20/solid"
import { V2ProjectId } from "@researchwiseai/identities"
import { useMemo, useState } from "react"
import { ProjectDeleteModal } from "./ProjectDeleteModal"
import { Dropdown, DropdownButton, DropdownItem, DropdownMenu } from "@ui/dropdown"

interface Props {
    projectId: string
}

export function ProjectOptions({ projectId: projectIdUrl }: Props) {
    const projectId = useMemo(() => V2ProjectId.fromUrl(projectIdUrl), [projectIdUrl])
    const [deleteProjectModalVisible, setDeleteProjectModalVisible] = useState(false)

    return (
        <>
            <Dropdown>
                <DropdownButton className="size-10" plain>
                    <EllipsisVerticalIcon className="size-5" aria-hidden="true" />
                    <span className="sr-only">
                        Actions for {projectId.id} in {projectId.region}
                    </span>
                </DropdownButton>
                <DropdownMenu anchor="bottom">
                    <DropdownItem onClick={() => setDeleteProjectModalVisible(true)}>Delete</DropdownItem>
                </DropdownMenu>
            </Dropdown>
            <ProjectDeleteModal
                projectId={projectId}
                visible={deleteProjectModalVisible}
                setVisible={setDeleteProjectModalVisible}
            />
        </>
    )
}
